<template>
  <div v-if="true" id="nav_collapse_new" class="header d-lg-flex">
    <div class="header_left align-items-center">
        <i @click="mobileMenuClicked" class="hamburger-menu material-icons text-color-white mr-3 cursor-pointer">
          {{ getNavMenuCloseIcon ? 'close' : 'menu' }}
        </i>
      <img
        :class="['header_logo']"
        :src="require('@/assets/logos/interview-sidebar-logo.svg')"
        alt="Interview.co logo"
        height="24"
      >
    </div>
    <div :class="['header_right']">
      <div>
        <b-dropdown id="dropdown-left" :text="language?.toUpperCase()" variant="primary" class="m-2" :class="['header_lang-changer', getResponsiveMenuStatus  ? 'd-none' : '']" @shown="gtmEventHandle()">
          <b-dropdown-item @click="changeLanguage(item)" v-for="item in languageItems" :key="item.id">{{ item.title }}</b-dropdown-item>
        </b-dropdown>
        <button :class="[
            { 'show': showLanguageModal },
            'language-change-button',
          ]" @click="showLanguageModal=true">{{language?.toUpperCase()}}</button>
        <b-modal v-model="showLanguageModal" id="modal-1" class="language-modal" hide-footer hide-header content-class="language-modal-content" dialog-class="language-modal-dialog" body-class="language-modal-body">
          <div class="w-100 d-flex align-items-center justify-content-end" @click="showLanguageModal=false"><i class="icon-close"></i></div>
          <button class="language-modal-item" @click="changeLanguage(item)" v-for="item in languageItems" :key="item.id">{{ item.title }}</button>
        </b-modal>
      </div>
      <b-navbar-nav
          id="nav_user_profile"
          class=""
      >
          <!-- notification center -->
          <b-nav-item-dropdown
          no-caret
          :class="['notification-center']"
          @show="notificationShow"
          @hide="notificationHide"
          >
          <template slot="text">
          </template>
          <div role="group">
              <b-dropdown-header>
                <span class="icon-left-arrow notification-center_close-menu"></span>
                <span class="notification-center_menu-title">{{ resource['navbar.NotificationCenter.Title'] }}</span>
              </b-dropdown-header>
          </div>
          </b-nav-item-dropdown>

      </b-navbar-nav>
    </div>
  </div>
</template>

<style lang="scss">
  @import "~@/style/starter.scss";
  .sidebarnew {
    .hamburger-menu {
        display: none;
        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
          display: block;
        }
      font-size: 25px;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 56px;
      padding: 8px 13px 8px 16px;
      margin-bottom: 8px;
      .opacity-effect {
        opacity: 0 !important;
        transition: opacity .1s !important;
      }
      &_logo {
        width: 120px;
        opacity: 1;
        transition: opacity .1s ease-in;
        height: 18px;
      }
      &_right {
        display: flex;
        align-items: center;
        opacity: 1;
        transition: opacity .1s !important;
        #dropdown-left {
          &.show {
            .btn {
              background-color:rgba(228, 228, 228, 0.15) !important;
              &::after{
                transform: rotate(180deg);
                margin-top: -3px;
              }
              &:hover{
                background-color:rgba(228, 228, 228, 0.15) !important;
              }
            }
          }
          .btn{
            border-radius: 4px;
            padding: 6px;
            background-color: #353535 !important;
            color: white !important;
            &::after{
              margin-top: 4px;
              border: 0 !important;
              transition: all 0.3s;
              content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M6.0937 6.74989L9.0037 9.65989L11.9137 6.74989C12.2062 6.45739 12.6787 6.45739 12.9712 6.74989C13.2637 7.04239 13.2637 7.51489 12.9712 7.80739L9.5287 11.2499C9.2362 11.5424 8.7637 11.5424 8.4712 11.2499L5.0287 7.80739C4.7362 7.51489 4.7362 7.04239 5.0287 6.74989C5.3212 6.46489 5.8012 6.45739 6.0937 6.74989Z" fill="white"/></svg>');
            }
          }
          .dropdown-menu {
            background-color: #ffffff !important;
            width: 100px;
            min-width: 100px;
            @include border-radius(4px);
            border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);
            box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
          }
          .dropdown-item {
            color: #333333 !important;
            text-transform: capitalize;
            padding: 6px 8px !important;
            font-family: Roboto;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            &:first-child{
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
            }
            &:last-child{
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
            }
            &:hover {
              background-color: #EEEEEE !important;
              color: #333333 !important;
            }
          }
        }
      }
      &_left {
        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
          display: flex;
        }
      }
      &_lang-changer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        @include border-radius(4px);
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        line-height: 18px;
        color: $white;
        text-transform: uppercase !important;
        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
          display: none;
        }
        &-mobile {
          position: fixed;
          left: 16px;
          bottom: 16px;
          z-index: 1 !important;
          @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
            display: flex;
            position: fixed;
            left: 0 !important;
            bottom: 0!important;
            z-index: 1 !important;
            width: 100%;
            text-align: left;
            justify-content: flex-start;
            height: 46px;
            padding-left: 16px;
            border-radius: 0;
            background: #353535;
          }
        }
      }
    }
    #nav_user_profile {
      @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
        height: 28px;
      }
      .notification-center {
        @include box-shadow(none);
        padding: 0;
        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
          padding: 0 83px 0 0;
        }
        a {
          overflow: inherit !important;
        }
        &:hover {
          .notification-center_button {
            background-color: rgba(228, 228, 228, 0.15) !important;
          }
        }
        &:before {
          display: none;
          content: "";
          position: absolute;
          right: -8px;
          top: 50%;
          margin-top: -9px;
          border-top: 9px solid transparent;
          border-bottom: 9px solid transparent;
          border-right: 9px solid $white;
          @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
            display: none !important;
          }
        }
        &_menu-title  {
          @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
            font-size: 16px;
            line-height: 24px;
            font-weight: 700;
          }
        }
        &_close-menu {
          &:before {
            @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
              display: none;
            }
          }
        }
        &.show {
          &:before {
            display: block;
          }
          .notification-center_icon-bell {
            &:before {
              content: '\e97d';
            }
          }
        }
        &_button {
          background: none !important;
          padding: 0;
          margin-left: 6px;
          position: relative !important;
          @include border-radius(4px);
          @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
            @include opacity(1 !important);
          }
        }
        &_icon-bell {
          font-size: 22px;
        }
        &_number {
          min-width: 12px;
          min-height: 12px;
          color: $white !important;
          z-index: 1;
          &.is-empty {
            right: 0px;
            top: 3px;
            @include border-radius(50%);
            &:before{
              content: '';
              width: 4px;
              height: 4px;
              @include border-radius(100%);
              background-color: $white;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }
          }
        }
        .dropdown-menu {
          width: 150px;
          min-width: 150px;
          display: block !important;
          position: absolute;
          margin: 0 0 0 36px;
          left: 0 !important;
          top: -5px !important;
          transform: none !important;
          visibility: hidden;
          border: 1px solid #E4E4E4;
          @include border-radius(4px);
          @include box-shadow(0px 0px 10px rgba(0, 0, 0, 0.25));
          @include opacity(0);
          @include transition (all, 0.2s, ease);
          @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
            position: fixed !important;
            top: 47px !important;
            height: 0 !important;
            max-height: 100%;
            width: 100% !important;
            margin: 0 !important;
            @include border-radius(0);
            @include opacity(1);
            > div {
              max-width: 100%;
            }
          }
          &.show {
            width: 330px;
            visibility: visible;
            @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
              height: calc(100% - 47px) !important;
            }
            @include opacity(1);
            @include transition (all, 0.2s, ease);
          }
          .dropdown-header {
            padding: 8px 16px !important;
          }
          a {
            &:hover {
              background-color: #E4E4E4;
            }
          }
        }
      }
    }
  }
  .language-modal-dialog {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    position: absolute;
    bottom: 0;
    height: 304px;
  }
  .language-modal-body{
    display: flex;
    flex-direction: column;
    max-height: 304px;
    .language-modal-item{
      border-bottom: 1px solid #E5E5E5 !important;
      padding-bottom: 16px;
      margin-top: 16px;
      color: #333333;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      &:last-child{
        border-bottom: none !important;
        padding-bottom: 0px;
        margin-bottom: 0px !important;
        margin-top: 0px;
      }
      &:first-child{
        margin-top: 0px !important;
      }
    }
  }
  .language-modal-content {
    height: 100%;
    border-radius: 0;
    border: 0;
  }
  .language-change-button{
    border-radius: 4px;
    padding: 6px;
    color: white;
    background-color: #333333;
    display: none;
    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      display: inline-flex;
    }
    &::after{
      content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M6.0937 6.74989L9.0037 9.65989L11.9137 6.74989C12.2062 6.45739 12.6787 6.45739 12.9712 6.74989C13.2637 7.04239 13.2637 7.51489 12.9712 7.80739L9.5287 11.2499C9.2362 11.5424 8.7637 11.5424 8.4712 11.2499L5.0287 7.80739C4.7362 7.51489 4.7362 7.04239 5.0287 6.74989C5.3212 6.46489 5.8012 6.45739 6.0937 6.74989Z" fill="white"/></svg>');
      margin-left: 0 !important;
      vertical-align: 0 !important;
      border: none !important;
      position: relative;
      top: 2px;
      transition: all 0.3s;
      margin-left: 6px !important;
    }
    &.show{
      &::after{
        transform: rotate(180deg);
        top:-3px;
      }
    }
  }
  .icon-close{
      color: #000000 !important;
      font-size: 20px !important;
    }
</style>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import {
  handleLoader,
} from '@/static/helpers';
import ResourceManager from '@/services/resource.service';
import { languageItems } from '@/static/languageItems';
import hrvenueService from '../../services/hrvenue.service';

export default {
  name: 'SideBarHeader',

  components: {
  },

  data() {
    return {
      socketServiceInstance: {},
      notifications: [],
      isFullscreenEnabled: true,
      hasFullscreenElement: null,
      hasNewNotification: false,
      notificationsLoading: false,
      notificationsSize: 5,
      lazyRequestControl: true,
      language: null,
      languageItems,
      showLanguageModal: false,
    };
  },

  computed: {
    ...mapGetters([
      'getNotifications',
      'getResponsiveMenuStatus',
      'getNavMenuCloseIcon',
    ]),
    showHeaderButtons () {
      return this.$route.name !== 'MailVerification' && this.$route.name !== 'GsmVerification';
    },
  },
  created() {
    let currentLanguage = null;
    if (typeof ResourceManager.CurrentLang !== 'string') {
      currentLanguage = ResourceManager.CurrentLang.key;
    } else {
      currentLanguage = this.languageItems.find((item) => item.code === ResourceManager.CurrentLang);
    }
    this.language = currentLanguage.key;
  },
  async destroyed () {
    const elemNotificationMenu = document.querySelectorAll('.notification-center .dropdown-menu')[0];
    if (elemNotificationMenu) {
      elemNotificationMenu.removeEventListener('scroll', this.notificationsHandleScroll);
    }
  },
  mounted() {},

  methods: {
    ...mapActions([
      'callSetResource',
    ]),
    gtmEventHandle() {
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'menu_click',
        event_parameters: {
          label: 'language-dropdown',
        },
        page_type: 'home/dashboard',
        site_type: 'interview',
      });
    },
    notificationShow() {
      this.setNavMenuCloseIcon(true);
    },
    notificationHide() {
      const isFooterShow = document.querySelector('.username-dropdown > ul').className.includes('show');
      if (!isFooterShow) {
        this.setNavMenuCloseIcon(false);
        this.setResponsiveMenuStatus(false);
      }
    },
    changeMobileMenuStatus() {
      this.setResponsiveMenuStatus();
      document.querySelector('.sidebarmenu-wrapper').style.transition = 'height ease .2s';
      setTimeout(() => {
        document.querySelector('.sidebarmenu-wrapper').style.transition = null;
      }, 200);
    },
    mobileMenuClicked() {
      if (!this.getNavMenuCloseIcon) {
        this.changeMobileMenuStatus();
      } else if (this.getNavMenuCloseIcon && this.getResponsiveMenuStatus) {
        this.changeMobileMenuStatus();
      }
      this.setNavMenuCloseIcon();
    },
    ...mapMutations(['updateNotificationProperty', 'addNotification', 'lazyNotification', 'setResponsiveMenuStatus', 'setNavMenuCloseIcon']),

    async changeLanguage(item) {
      ResourceManager.CurrentLang = item.code;
      window.localStorage.setItem('locale', item.key);
      handleLoader.showLoader();
      await hrvenueService.setUserLanguage(item.id);

      const currentRoute = this.$route;
      const newLang = item.key;
      if (currentRoute.params.lang === newLang) {
        handleLoader.hideLoader();
        return;
      }

      const newRoute = {
        name: currentRoute.name,
        params: { ...currentRoute.params, lang: newLang },
        query: currentRoute.query,
      };

      this.$router.push(newRoute).catch((error) => {
        if (error.name !== 'NavigationDuplicated') {
          //
        }
        handleLoader.hideLoader();
      }).then(() => {
        ResourceManager.Get().then((res) => {
          this.language = newLang;
          this.callSetResource({
            ...res,
            CurrentLang: ResourceManager.CurrentLang,
          });
          handleLoader.hideLoader();
        }).catch((resourceError) => {
          // eslint-disable-next-line no-console
          console.error('Resource yüklenirken hata oluştu:', resourceError);
          handleLoader.hideLoader();
        });
      });
    },
  },
};
</script>
